import React from 'react'
import JumpStartServiceComponent from '../Components/JumpStartServiceComponent'
import AdminHeaderComponent from '../Components/AdminHeaderComponent'

function JumpStartServicePage() {
  return (
    <div>
      {/* <AdminHeaderComponent/> */}
        <JumpStartServiceComponent />
    </div>
  )
}

export default JumpStartServicePage